/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadContractSlipPayloadDto
 */
export interface UploadContractSlipPayloadDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadContractSlipPayloadDto
     */
    fileIds?: Array<string>;
}

/**
 * Check if a given object implements the UploadContractSlipPayloadDto interface.
 */
export function instanceOfUploadContractSlipPayloadDto(value: object): value is UploadContractSlipPayloadDto {
    return true;
}

export function UploadContractSlipPayloadDtoFromJSON(json: any): UploadContractSlipPayloadDto {
    return UploadContractSlipPayloadDtoFromJSONTyped(json, false);
}

export function UploadContractSlipPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadContractSlipPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
    };
}

export function UploadContractSlipPayloadDtoToJSON(json: any): UploadContractSlipPayloadDto {
    return UploadContractSlipPayloadDtoToJSONTyped(json, false);
}

export function UploadContractSlipPayloadDtoToJSONTyped(value?: UploadContractSlipPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileIds': value['fileIds'],
    };
}

